/**
 * Register Hear Control service worker (app-shell only).
 */

let registered = false;
let controllerListenerBound = false;

/**
 * @returns {boolean}
 */
function canRegister() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }
  if (!("serviceWorker" in navigator)) {
    return false;
  }
  const host = window.location.hostname;
  const secure =
    window.location.protocol === "https:" ||
    host === "localhost" ||
    host === "127.0.0.1";
  return secure;
}

/**
 * Register /sw.js once per page load.
 * @returns {Promise<ServiceWorkerRegistration|null>}
 */
export async function registerHearPwa() {
  if (!canRegister() || registered) {
    return null;
  }
  registered = true;

  try {
    const registration = await navigator.serviceWorker.register("/sw.js", {
      scope: "/",
    });

    if (!controllerListenerBound && navigator.serviceWorker) {
      controllerListenerBound = true;
      let refreshing = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (refreshing) return;
        refreshing = true;
        /* Soft signal only — no forced reload (plan). */
        try {
          import("/assets/js/utils/toast-message.js")
            .then(({ showToast }) => {
              showToast({
                message: "Atualização disponível — recarregue a página.",
                type: "info",
              });
            })
            .catch(() => {});
        } catch {
          /* ignore */
        }
      });
    }

    return registration;
  } catch {
    registered = false;
    return null;
  }
}

/**
 * Unregister all Hear service workers (rare; tests / diagnostics).
 * @returns {Promise<void>}
 */
export async function unregisterHearServiceWorker() {
  if (!canRegister()) return;
  const regs = await navigator.serviceWorker.getRegistrations();
  await Promise.all(regs.map((r) => r.unregister()));
  registered = false;
}

/**
 * Delete hear-shell-* Cache Storage entries.
 * Prefer keeping shell on logout (offline message); expose for diagnostics.
 * @returns {Promise<void>}
 */
export async function purgeHearShellCaches() {
  if (typeof globalThis.caches === "undefined") return;
  const keys = await globalThis.caches.keys();
  await Promise.all(
    keys.filter((k) => k.startsWith("hear-shell-")).map((k) => globalThis.caches.delete(k)),
  );
}
